import { render, staticRenderFns } from "./supportPage.vue?vue&type=template&id=08302faa&scoped=true&"
import script from "./supportPage.vue?vue&type=script&lang=js&"
export * from "./supportPage.vue?vue&type=script&lang=js&"
import style0 from "./supportPage.vue?vue&type=style&index=0&id=08302faa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08302faa",
  null
  
)

export default component.exports